angular.module('unergie.main')
.controller('enedisServicesModalCtrl', ($scope, $uibModalInstance, AlertManager, ErrorCatcher, DataAccess, ApiUser, idContract) => {
    $scope.idContract = idContract

    $scope.refreshWithDB = () => {
        $scope.refreshing = true
        DataAccess.getContractElecEnedisServices({ id_contract: idContract }).$promise.then((result) => {
            $scope.enedisServices = _.orderBy(result, ['type', 'measure_type'])
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshing = false
        })
    }

    $scope.refreshWithDB()

    $scope.refreshWithEnedis = () => {
        $scope.refreshing = true
        return ApiUser.refreshContractElecEnedisServices({ id_contract: idContract }).$promise.then((result) => {
            $scope.enedisServices = _.orderBy(result, ['type', 'measure_type'])
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshing = false
        })
    }

    $scope.oppositionCurvesRecording = () => {
        $scope.opposing = true
        return ApiUser.oppositionCurvesRecording({ id_contract: idContract }, {}).$promise.then((result) => {
            AlertManager.success(`Opposition demandée, rafraîchissement du statut des services.`)
            $scope.refreshWithEnedis()
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.opposing = false
        })
    }

    $scope.syncWithEnedisPayload = {
        force: false,
    }

    $scope.syncWithEnedisFields = {
        label: {
            label: `<span class="fa fa-warning red"></span> Cela effectuera les demandes d'activation ou d'arrêt de service auprès d'enedis en fonction des consentements du contrat.`,
            type: 'label',
        },
        force: {
            label: 'Forcer',
            type: 'checkbox',
        },
    }

    $scope.syncWithEnedis = () => {
        $scope.synchronizing = true
        return ApiUser.synchronizeContractElecEnedisServices(_.assign({ id_contract: idContract }, $scope.syncWithEnedisPayload), {}).$promise.then((result) => {
            AlertManager.success(result.message, 10000, result.messages)
            $scope.refreshWithDB()
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.synchronizing = false
        })
    }

    $scope.close = () => $uibModalInstance.dismiss()
})
